import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Terms from "../modals/terms";
import { useLoading } from "../contexts/LoadingContext";

const CenteredModal = ({ show, handleClose, terms }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="p-3"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Terms And Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: terms }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const PackageScreen = ({ items }) => {
  const [loading, setLoading] = useState(true);
  const { isLoading, setIsLoading } = useLoading();
  const [selectedOption, setSelectedOption] = useState(items[0]?.badge || "");
  const terms = new Terms().getTerms();
  const [description, setDescription] = useState(
    items.length > 0 ? items[0].description : ""
  );
  const [coverage, setCoverage] = useState(
    items.length > 0 ? items[0].coverage : ""
  );
  const [show, setShow] = useState(false);
  const navigate = useNavigate(); // Initialize navigate

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleButtonClick = (item) => {
    setSelectedOption(item.badge);
    setDescription(item.description);
    setCoverage(item.coverage);
  };

  useEffect(() => {
    const selectedItem = items.find(
      (item) => item.badge.toLowerCase() === selectedOption.toLowerCase()
    );
    if (selectedItem) {
      setDescription(selectedItem.description);
    }
  }, [selectedOption, items]);

  const handlePayNowClick = async () => {
    setIsLoading(true);
    try {
      const msisdn = sessionStorage.getItem("decryptedMsisdn"); // Get msisdn from session storage
      if (!msisdn) {
        throw new Error("MSISDN not found in session");
      }
      const selectedItem = items.find(item => item.badge === selectedOption);
      console.log(selectedItem);
      // Extract serviceId from the URL
      const currentUrl = window.location.pathname;
      const serviceId = currentUrl.split("/").pop(); // Assuming the serviceId is the last part of the URL

      // Make API call to send OTP
      const response = await fetch(
        "https://bankalfalah.webddocsystems.com/smosa.php/sendOTP",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic RE9UVXNlcm5hbWUxOkRPVFBhc3MyMTNAIQ==",
            PartnerId: "partner-a5d477b9-c77c-48d5-b9d0-df2d71370680",
            Accept: "application/json",
          },
          body: JSON.stringify({
            msisdn,
          }),
        }
      );

      // Log the entire response object for debugging
      const responseText = await response.text();
      console.log("API Response:", responseText);

      if (response.ok) {
        const data = JSON.parse(responseText); // Parse the response text to JSON
        console.log("OTP Sent:", data.otp);
        console.log("pid:", selectedItem.pid);
        navigate(`/otpscreen`, {
          state: {
            serviceId,
            pid: selectedItem.pid,
          },
        });
      } else {
        throw new Error("Failed to send OTP. Response not OK.");
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message,
        icon: "error",
      });
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <div className="row m-3 mt-2 position-relative">
          <div className="col-12 text-center">
            <p className="custome-textfont">
              Select price point to subscribe the service
            </p>
          </div>
          <div className="col-12">
            <div className="card">
              <div className="row d-flex justify-content-center">
                {items.map((item, index) => (
                  <div className="col-4 text-center mb-1 p-2" key={index}>
                    <Button
                      style={{
                        background: selectedOption === item.badge
                          ? "linear-gradient(to left, rgba(200, 79, 146, 0.8) 42%, rgba(107, 40, 124, 0.8) 90%)"
                          : "transparent", // Make non-selected buttons transparent
                        border: selectedOption === item.badge ? "none" : "1px solid #dee2e6",
                        color: selectedOption === item.badge ? "white" : "black",
                      }}
                      className="w-100 p-2"
                      onClick={() => handleButtonClick(item)}
                    >
                      {item.badge} <br />
                      Rs. {item.price}
                    </Button>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className="col-12">
                  <hr />
                </div>
              </div>
              {coverage !== "-" && (
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex flex-column">
                      <p className="dark-border rounded-border bg-secondary p-3 fs-15 text-white">
                        Coverage:
                        <strong
                          className="float-end"
                          style={{ fontSize: "15px", color: "white" }}
                        >
                          {" "}
                          Rs. {coverage}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-12">
                  <p
                    id="description"
                    className="custome-textfont"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5 pt-5">
        <div className="row d-flex justify-content-center">
          <div className="col-12 text-center mb-3">
            <small>
              By clicking <strong>"Pay Now"</strong> you are accepting our{" "}
              <br></br>
              <a href="javascript:void(0);" onClick={handleShow}>
                Terms & conditions
              </a>
            </small>
          </div>
          <div className="col-12">
            <button
              className="btn paynowbtn w-100 p-2"
              onClick={handlePayNowClick}
              style={{ color: "white" }}
            >
              Pay Now
            </button>
          </div>
        </div>
      </div>

      <CenteredModal show={show} handleClose={handleClose} terms={terms} />
    </>
  );
};

export default PackageScreen;
